import { Spin } from 'antd';
import { Suspense } from 'react';
import { TrackingProvider } from '@/core/tracking/tracking.provider';
import type { ItemMenu } from '@/domain/menu.ts';
import type { SingleTab } from '@/domain/singleTab.ts';

export class TabsManager {
  private tabs: SingleTab[] = [];

  constructor(initialTabs: SingleTab[] = []) {
    this.tabs = initialTabs;
  }

  addTab(tab: SingleTab): void {
    if (!this.tabs.some((t) => t.key === tab.key)) {
      this.tabs.push(tab);
    }
  }

  addTabByTabPage(
    tabPage: ItemMenu,
    id?: string,
    mediaType?: string,
    source?: string,
    calidad?: string,
    openModal?: boolean,
    activeKey?: string,
    seekTime?: number
  ): SingleTab {
    const isTabOpened = this.filterTabByKey(tabPage.key);
    if (isTabOpened.length === 0 || tabPage.isMultiInstance) {
      let newKey = tabPage.key;

      if (id) {
        newKey = tabPage.key.concat('-', id ?? '');
      }
      const { Component = () => null, label, icon } = tabPage;

      const newTab: SingleTab = {
        key: newKey,
        label,
        icon,
        children: (
          <Suspense fallback={<Spin />}>
            <TrackingProvider module={tabPage.module ?? 'Unknown123'} screen={tabPage.key}>
              <Component
                id={id}
                mediaType={mediaType}
                source={source}
                calidad={calidad}
                openModal={openModal}
                activeKey={activeKey}
                myKey={newKey}
                seekTime={seekTime}
              />
            </TrackingProvider>
          </Suspense>
        ),
      };
      this.addTab(newTab);
      return newTab;
    }

    return isTabOpened[0];
  }

  removeTab(tabId: string): void {
    this.tabs = this.tabs.filter((tab) => tab.key !== tabId);
  }

  findIndex(tabId: string): number {
    return this.tabs.findIndex((tab) => tab.key === tabId);
  }

  filterTabByKey(tabId: string): SingleTab[] {
    return this.tabs.filter((tab) => tab.key === tabId) || [];
  }

  getTabs(): SingleTab[] {
    return this.tabs;
  }
}
